// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OrgStaffOutlinedSvg from "@fishx/icons-svg/es/asn/OrgStaffOutlined";
import FishxIcon from '../components/FishxIcon';

var OrgStaffOutlined = function OrgStaffOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: OrgStaffOutlinedSvg
  }));
};

OrgStaffOutlined.displayName = 'OrgStaffOutlined';
export default React.forwardRef(OrgStaffOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/OrgStaffOutlined.js
// module id = 3185
// module chunks = 0